import { ProcessStatusEnum } from "@modules/api/process-status-enum.generated";
import { ProcessStepStatusEnum } from "@modules/common/enums/process-step-status.enum";

/**
 * Turns the given publishing step status into the corresponding
 * process step status, used by the process execution status component.
 */
export function getStepStatus(status: ProcessStatusEnum): ProcessStepStatusEnum {
	switch (status) {
		case ProcessStatusEnum.NotStarted:
			return ProcessStepStatusEnum.NotStarted;
		case ProcessStatusEnum.InProgress:
			return ProcessStepStatusEnum.InProgress;
		case ProcessStatusEnum.Complete:
			return ProcessStepStatusEnum.Complete;
	}
}